const scrollLockClass = 'sg-page-scroll-lock';
const scrollOffsetVar = '--sg-scroll-offset';

let cachedRootStyles = null;

function emitDialogCloseEvent(event) {
    const dialog = event.target;
    const customEvent = new CustomEvent('dialogClosed', {
        detail: { dialog }
    });
    document.dispatchEvent(customEvent);
}

function lockPageScroll() {
    document.documentElement.style.setProperty(scrollOffsetVar, window.scrollY);
    document.documentElement.classList.add(scrollLockClass); 
}

function unlockPageScroll() {
    const scrollY = parseInt(getCSSCustomProperty(scrollOffsetVar, true));
    document.documentElement.classList.remove(scrollLockClass);
    window.scrollTo({ top: scrollY, behavior: 'instant' });
}

/**
* Fetches the value of a CSS custom property (variable) from :root
* @param {string} propertyName - The name of the CSS custom property (e.g., '--sg-media-bp-xsmall')
* @param {boolean} forceUpdate - If true, recalculates and updates the cache
* @return {string} - The value of the CSS custom property
*/
function getCSSCustomProperty(propertyName, forceUpdate = false) {
    if (!cachedRootStyles || forceUpdate) {
        cachedRootStyles = getComputedStyle(document.documentElement);
    }
    return cachedRootStyles.getPropertyValue(propertyName).trim();
}

export {
    emitDialogCloseEvent,
    lockPageScroll,
    unlockPageScroll,
    getCSSCustomProperty
};
